import {useState} from 'react';
import {InputNumber} from 'antd';

export const GramsEntryWidget = ({value, placeholder, min, max, precision, addonAfter, onChange, props}) => {
    const [val, setVal] = useState(value);
    const [active, setActive] = useState(false);

    const onClick = () => {
        setVal(value);
        setActive(true);
    }

    const onInputChange = (val) => {
        setVal(val);
    }

    const onInactive = () => {
        if (onChange) {
            onChange(val);
        }
        setActive(false);
    }

    const onMouseLeave = () => {
        onInactive();
    }

    const onBlur = () => {
        onInactive();
    }

    if (active) {
        return <InputNumber addonAfter={addonAfter} min={min} max={max} precision={precision} onChange={onInputChange} value={value}
            onMouseLeave={onMouseLeave} onBlur={onBlur} placeholder={placeholder} />
    } else {
        return <div style={{cursor: "pointer", color: "#108ee9"}} onClick={onClick}>{`${value} ${addonAfter}`}</div>
    }
}